import { ITypographComponent } from '../../interfaces/IComponents';
import clsx from 'clsx';
import styles from './EpTypograph.module.scss';

/**
 * Typograph Title component
 */

const headingLevels = {
  1: 'h1',
  2: 'h2',
  3: 'h3',
  4: 'h4',
  5: 'h5',
  6: 'h6',
};

export const EpTypographTitle = ({
  align,
  children,
  color,
  customClass,
  fweight,
  level,
  size,
}: ITypographComponent) => {
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  const Component: any = level
    ? headingLevels[level as keyof typeof headingLevels]
    : 'h1';
  const fillColor = `typograph--color-${color}`;
  const fontSize = `typograph--size-${size}`;
  const fontWeight = `typograph--weight-${fweight}`;
  const textAlign = `typograph--align-${align}`;

  return (
    <Component
      className={clsx(
        styles[fillColor],
        styles[fontSize],
        styles[fontWeight],
        styles[textAlign],
        customClass,
      )}
    >
      {children}
    </Component>
  );
};
